import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-email-address',
  styleUrl: 'address.css',
  shadow: true,
})
export class Email {
  @Prop() emailLabel: string = "Email";
  @Prop() emailLink: string = "mailto:help@case.edu";
  @Prop() emailLinkText: string = "help@case.edu";

  render() {
    return (
      <div class="email-full">
        <p class="contact email">{this.emailLabel}: <a href={this.emailLink}>{this.emailLinkText}</a></p>
      </div>
    );
  }
}